import React from 'react';
import { ArrowRightIcon, BathIcon, ChefHatIcon, GemIcon, GridIcon, HammerIcon, HomeIcon, LayersIcon, LayoutPanelLeftIcon, PaintbrushIcon, WrenchIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  'granite-countertops': GemIcon,
  'kitchen-remodeling': ChefHatIcon,
  'bathroom-design': BathIcon,
  roofing: HomeIcon,
  painting: PaintbrushIcon,
  'drywall-interior': LayersIcon,
  'wood-rot-repair': HammerIcon,
  'tile-flooring': GridIcon,
  'custom-cabinetry': LayoutPanelLeftIcon,
  handyman: WrenchIcon
};
export function Services() {
  const {
    t
  } = useLanguage();
  const lastIndex = t.services.items.length - 1;
  return <section id="services" className="w-full bg-white py-16 lg:py-20" data-id="element-330" data-mp="l7g73drh7s6d">
      <div className="mx-auto max-w-shell px-4 sm:px-6 lg:px-8" data-id="element-331" data-mp="g7lglbbm54lu">
        <SectionHeading title={t.services.title} subtitle={t.services.subtitle} data-id="element-332" data-mp="36by0cmb6wlj0" />

        <ul className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8" data-id="element-333" data-mp="3b36bpnw2ygyt">
          {t.services.items.map((service, index) => {
          const Icon = icons[service.id] ?? GemIcon;
          const wide = index === lastIndex;
          return <Reveal as="li" key={service.id} delay={Math.min(index, 5) * 0.04} className={`h-full ${wide ? 'sm:col-span-2 lg:col-span-3' : ''}`} data-id="element-334" data-mp="32b4c1rtu54pl" data-mpi={index}>
                <article className={`group flex h-full flex-col border-l-4 border-l-transparent border-y border-r border-black/10 bg-white p-7 shadow-card transition-[transform,box-shadow,border-color] duration-200 ease-smooth hover:-translate-y-1 hover:border-l-brand-500 hover:shadow-lift lg:p-8 ${wide ? 'lg:flex-row lg:items-center lg:gap-10' : ''}`} data-id="element-335" data-mp="3g29fz648kj5q">
                  <Icon className="h-9 w-9 shrink-0 text-brand-500" aria-hidden="true" data-id="element-336" data-mp="1pkcf09m9lkoh" />
                  <div className={wide ? 'lg:flex-1' : ''} data-id="element-337" data-mp="1lhza1nfcdqsr">
                    <h3 className="mt-5 font-display text-xl font-extrabold text-ink lg:mt-0 lg:text-2xl" data-id="element-338" data-mp="1lkv4h1rzdxcg">
                      {service.name}
                    </h3>
                    <p className="mt-3 max-w-2xl text-sm leading-relaxed text-[#5B5B5B]" data-id="element-339" data-mp="1bs687e504q1p">
                      {service.description}
                    </p>
                  </div>
                  <a href="#contact" className={`inline-flex items-center gap-1.5 self-start text-sm font-bold text-brand-600 underline decoration-brand-500/40 decoration-2 underline-offset-4 transition-colors duration-200 ease-smooth hover:text-ink hover:decoration-brand-500 ${wide ? 'mt-6 lg:mt-0 lg:shrink-0' : 'mt-auto pt-6'}`} data-id="element-340" data-mp="11tgnldlq0rhr">
                    {t.services.learnMore}
                    <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-smooth group-hover:translate-x-1" aria-hidden="true" data-id="element-341" data-mp="2urvr6k2dsb5p" />
                  </a>
                </article>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}